/**
 * Опрос /fatsecret/status — только пока клиент подключает FatSecret.
 *
 * Раньше Home, Diary и Profile опрашивали статус каждые 3 с всё время, пока
 * FatSecret не подключён, — то есть у большинства клиентов, бесконечно:
 * ~1000 запросов в час на одно открытое окно (fb-04 «приложение лагает»).
 * Опрос нужен лишь затем, чтобы карточка перевернулась в «Подключено» сразу
 * после OAuth во внешнем браузере. Поэтому теперь он идёт только окно
 * FATSECRET_CONNECT_POLL_MS после нажатия «Подключить»; возврат в окно
 * по-прежнему обновляет статус (refetchOnWindowFocus).
 */

export const FATSECRET_POLL_INTERVAL_MS = 3000
export const FATSECRET_CONNECT_POLL_MS = 5 * 60 * 1000

let connectStartedAt: number | null = null

/** Клиент начал подключение FatSecret — включаем опрос статуса. */
export function markFatSecretConnectStarted(now: number = Date.now()): void {
  connectStartedAt = now
}

/** Интервал опроса статуса для useQuery: false — не опрашивать. */
export function fatSecretStatusRefetchInterval(
  connected: boolean | undefined,
  now: number = Date.now(),
): number | false {
  if (connected) return false
  if (connectStartedAt == null || now - connectStartedAt > FATSECRET_CONNECT_POLL_MS) return false
  return FATSECRET_POLL_INTERVAL_MS
}

/** Для тестов. */
export function resetFatSecretConnectPolling(): void {
  connectStartedAt = null
}
